/** tm/components/FpFitLine.tsx — 업체 상세 「정부지원사업 매칭」 칸 위 한 줄: 팀장님 문답 답(2026-10-26 · services/clientFit)
 *  지도사 「팀장님이 간단한 문답만 채워주면 임지도사가 채워드립니다」 — 매칭 정보를 채울 때 팀장님이 뭐라고 했는지 바로 보이게.
 *  답이 없으면 아무것도 안 그린다. refreshKey(업체 updated_at)가 바뀌면 다시 읽는다. */
import { useEffect, useState } from 'react';
import { req } from '../api';
import { C, T } from './ui';

type Ans = 'yes' | 'no' | 'unknown' | '';
interface Fit { own_product: Ans; makes: Ans; store: Ans; answered_at: string; filled_at: string }
const Q: [keyof Pick<Fit, 'own_product' | 'makes' | 'store'>, string][] = [['own_product', '자체 제품'], ['makes', '직접 생산'], ['store', '매장']];
const SAY: Record<Ans, string> = { yes: '예', no: '아니요', unknown: '모름', '': '답 안 함' };

export default function FpFitLine({ companyId, refreshKey }: { companyId: string; refreshKey?: string | null }) {
  const [fit, setFit] = useState<Fit | null>(null);
  useEffect(() => {
    let live = true;
    setFit(null);
    req<Fit | null>('GET', `/client-desk/fits/${companyId}`).then((r) => { if (live && r.success) setFit(r.data || null); }).catch(() => { /* 한 줄 안내라 실패하면 그리지 않음 */ });
    return () => { live = false; };
  }, [companyId, refreshKey]);
  if (!fit || !Q.some(([k]) => fit[k])) return null;
  const day = fit.answered_at ? `${+fit.answered_at.slice(5, 7)}. ${+fit.answered_at.slice(8, 10)}.` : '';
  return (
    <div style={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center', gap: 6, marginBottom: 10, fontSize: T.xs, color: C.sub }}>
      <b style={{ color: C.text }}>팀장님 답</b>
      {Q.map(([k, l]) => (
        <span key={k} style={{ padding: '2px 8px', borderRadius: 6, fontWeight: 700, background: fit[k] === 'yes' ? '#E8EEF6' : fit[k] === 'no' ? '#F3F4F6' : '#fff', color: fit[k] === 'yes' ? '#1B3A5C' : '#4B5563', border: fit[k] === 'yes' || fit[k] === 'no' ? '1px solid transparent' : `1px dashed ${C.border}` }}>{l} {SAY[fit[k]]}</span>
      ))}
      <span>{day}{fit.filled_at ? ' · 채움' : ''}</span>
    </div>
  );
}
